import React, { FC } from 'react'
import classNames from 'classnames'
import styles from '../solidsport.module.scss'
import { ComingSoon } from '../comingSoon/ComingSoon'
import ComingSoonPage from 'pages/ComingSoonPage/ComingSoonPage'
import { useWithTheme } from 'hooks/useWithTheme/useWithTheme'

interface AppLayoutProps {
  children: React.ReactNode
  comingSoon: boolean
  comingSoonAttributes: ComingSoon
  releaseDate: number | undefined
}

export const AppLayout: FC<AppLayoutProps> = ({
  comingSoon,
  comingSoonAttributes,
  releaseDate,
  children
}) => {
  useWithTheme()
  return (
    <div className={classNames('SolidSport', styles.SolidSport)}>
      {comingSoon ? (
        <ComingSoonPage
          releaseDate={releaseDate!}
          backgroundImageUrl={comingSoonAttributes.backgroundImageUrl!}
          logoImageUrl={comingSoonAttributes.logoUrl!}
          vanityUrl={comingSoonAttributes.vanityUrl!}
          channelSlug={comingSoonAttributes.channelSlug!}
        />
      ) : (
        children
      )}
    </div>
  )
}
